import React,  { useState } from "react";
import ModalConfirm from '../../utils/form/modalConfirmBase';
import { createCharge } from '../../actions/charge-actions';
import ConfirmDialog from "../../utils/form/confirmDialog";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useStateValue } from '../../context/store';
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { 
  Grid, 
  TextField, 
  FormControl, 
  Typography, 
  Card, 
  Button,
  CardContent,
  FormHelperText
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import { REQUIRED_MESSAGE } from "../../constants";
import { styles } from '../styles';
import { titleCase } from 'title-case';
import * as yup from "yup";

const defaultValues = {
  denomination: '',
  approvers: [],
};


const Charges = ({closeCreate, charges, resetData}) => {

  const [resetForm, setResetForm] = useState({
    denomination: '',
    approvers: [],
  })
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [, dispatch] = useStateValue();
  const classes = styles();
  
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
  });
  const [message, setMessage] = useState({
    description : '',
    textButtonSubmit : '',
    handleClick : () => {} ,
    handleClickOut : () => {},
    oneButtons : false,
    type : '',
    open : false
})
  
  const schema = yup.object().shape({
    denomination: yup.string().required(REQUIRED_MESSAGE).min(5, 'Ingrese mínimo 5 caracteres').max(60, 'Ingrese máximo 60 caracteres'),
    approvers: yup.string(),
  });

  const { register, handleSubmit,  errors, watch, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "onTouched",
    reValidateMode: "onBlur",
  });

  const onChangeValues =(e) => {
    const { name, value } = e.target;
        setResetForm({ ...resetForm, [name]: value });
  }


  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  //const handleClickOut = () => setMessage({...message, open: false});
  const handleClickClose = () => {setMessage({...message, open: false}); setSubmitDisabled(false);};


  const onSubmit = (info) => {
   
    setMessage({
      description : "¿Está seguro que desea crear el registro?",
      textButtonSubmit : 'Aceptar',
      handleClick : () => handleClick(info),
      handleClickOut: () => handleClickClose(),
      type : 'WARNING',
      open : true
  })
    }

  const handleClick = (data) => {
    setSubmitDisabled(true)
    setMessage({...message, open: false});
    closeModal();
    const allApprovers = [...resetForm.approvers.map(function (item) {
      return item['id']})];
    const user = { 'creationUser' : 'DEVELOPER' };
    const newData = { ...data, ...user, approvers: allApprovers.join(',') };
      const create = async() => {
        const response = await createCharge(newData);
        if (response && response?.status === 200 || response?.status === 201) {
        setMessage({
          description : `Cargo creado exitosamente`,
          textButtonSubmit : 'Aceptar',
          oneButtons: true,
          handleClick : () =>  handleClickClose(),
          type : 'SUCCESS',
          open : true
      })
                resetData();
                setValue('denomination')
                setResetForm(defaultValues);
                setSubmitDisabled(false);
                // setMessage({...message, open: false});
          } else {
              setMessage({
                description : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
                textButtonSubmit : 'Aceptar',
                oneButtons: true,
                handleClick : () =>  handleClickClose(),
                type : 'WARNING',
                open : true
            })
          }}
        create();
   
  }

  const valueTypeDocument = watch("approvers")

  return (
    <>
    <ConfirmDialog
        open={confirm.open}
        body={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
      />
       <Card elevation = {0} style={{background: '#e0f2f7'}}>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <Typography component='h1' variant='h4' style={{textAlign:'center'}}>

        </Typography>
        <Grid container spacing={3} alignItems="center" style = {{background: '#BAE5F9', borderRadius: 15, display: 'flex'}}>
          <Grid item xs={12} md={6} lg={4}>
          <FormControl fullWidth >
                <TextField
                    // style = {{top: 5}}
                    fullWidth
                    defaultValue = ''
                    variant="outlined"
                    inputRef={register }
                    onChange={onChangeValues}
                    label="Nombre"
                    className = { classes.dropdownMultiple}
                    required
                    placeholder="Nombre del cargo"
                    name="denomination"
                    InputLabelProps={{ shrink: true }} 
                    error={!!errors.hasOwnProperty("denomination") && errors["denomination"].message}
                />
                 <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty('denomination') && errors['denomination'].message}
                </FormHelperText>
            </FormControl>
          </Grid>
          <Grid  item xs={12} md={6} lg={4}>
            <FormControl fullWidth >
              <Autocomplete
                multiple
                name="approvers"
                value={resetForm?.approvers}
                options={resetForm?.approvers?.length === 5 ? [] : charges}
                className = {classes.dropdownMultiple}
                onChange={(e, newval, reason) => {
                  setResetForm({...resetForm, approvers:newval});
                }}
                error={valueTypeDocument }
                getOptionLabel={(option) => titleCase(option.denomination)}
                renderInput={(params) => (
                        <TextField
                        {...params}
                        variant="outlined"
                        name="approvers"
                        label="¿Quién aprueba?"
                        InputLabelProps={{ shrink: true }} 
                        placeholder="¿Quién aprueba?"
                    />
                                      
                )}
            />
          </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: "12px"}}>
          {/* <BorderRedButton onClick={cancelConfirm}>CANCELAR</BorderRedButton>&nbsp;&nbsp; */}
          <Button 
            variant="contained" 
            type="submit" 
            disabled={submitDisabled} 
            className = { classes.create } 
            disableElevation
          >
            FINALIZAR
          </Button >
          &nbsp;&nbsp;
        </Grid>
          <ModalConfirm 
            description = { message.description }
            textButtonSubmit = { message.textButtonSubmit }
            handleClick = { message.handleClick }
            handleClickOut = { message.handleClickOut }
            oneButtons = { message.oneButtons }
            type = { message.type }
            open = { message.open }
          />
        </Grid>
        </form>
      </CardContent>
    </Card>
    </>
  );
}


export default withRouter(Charges);